import { useChatContext } from '@/contexts/chat/context';
import ChatHeaderMediaCall from '@/pages/messages/components/chat/chat-main/components/chat-header/components/chat-header-media-call';
import { useSessionContext } from '@/contexts/session/context';
import MoreIcon from '../../images/more.svg?react';
import CallIcon from '../../images/call.svg?react';
import ChatIcon from '../../images/chat.svg?react';
import giftIcon from '../../images/gift.png';
import styles from './index.module.scss';

const ReceiverActions = () => {
  const { showProfileInfo } = useSessionContext();
  const { info } = showProfileInfo;

  const { createOrActiveChat, createChat, chatMediaCall, mediaCallSingle } =
    useChatContext();
  const { online } = useNetwork();

  const sendMediaCall = useCallback(
    async (item: { key: string }) => {
      if (!online) {
        message.error('Network error.');
        return;
      }
      const chat = await createChat({ userId: info.userId! });
      if (chat) {
        mediaCallSingle({ chat_id: chat.chat_id, payload_type: Number(item.key) });
      }
    },
    [createChat, info.userId, mediaCallSingle, online]
  );

  const navData = [
    {
      key: 'Call',
      icon: <CallIcon />,
      text: 'Call',
    },
    {
      key: 'Chat',
      icon: <ChatIcon />,
      text: 'Chat',
      onclick: async () => {
        await createOrActiveChat({ userId: info.userId! }).catch((_) => '');
      },
    },
    {
      key: 'Gift',
      icon: <img src={giftIcon} />,
      text: 'Send Gift',
      onclick: () => {},
    },
    {
      key: 'More',
      icon: <MoreIcon />,
      text: 'More',
      onclick: () => {},
    },
  ];
  return (
    <div className={styles.receiverActions}>
      {navData.map((item) => {
        const Item = (
          <>
            <div>{item.icon}</div>
            <div className={styles.text}>{item.text}</div>
          </>
        );
        if (item.key === 'Call') {
          return (
            <ChatHeaderMediaCall
              className={styles.item}
              key={item.key}
              onClick={sendMediaCall}
              chatMediaCall={chatMediaCall}
            >
              {Item}
            </ChatHeaderMediaCall>
          );
        }
        return (
          <div key={item.key} className={styles.item} onClick={item?.onclick}>
            {Item}
          </div>
        );
      })}
    </div>
  );
};

export default ReceiverActions;
